import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import { hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
export var SequenceNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(SequenceNode, _DataFlowNode);

  function SequenceNode(parent, params) {
    var _this;

    _classCallCheck(this, SequenceNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SequenceNode).call(this, parent));
    _this.params = params;
    return _this;
  }

  _createClass(SequenceNode, [{
    key: "clone",
    value: function clone() {
      return new SequenceNode(null, this.params);
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      var _a;

      return new Set([(_a = this.params.as) !== null && _a !== void 0 ? _a : 'data']);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "Hash ".concat(_hash(this.params));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign({
        type: 'sequence'
      }, this.params);
    }
  }]);

  return SequenceNode;
}(DataFlowNode);